@file:OptIn(InternalResourceApi::class)

package banko.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/banko.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_090_057_042)
public val Res.font.fredoka: FontResource by lazy {
      FontResource("font:fredoka", setOf(
        ResourceItem(setOf(), "${MD}font/fredoka.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(306_444_414)
public val Res.font.luckiest_guy: FontResource by lazy {
      FontResource("font:luckiest_guy", setOf(
        ResourceItem(setOf(), "${MD}font/luckiest_guy.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("fredoka", Res.font.fredoka)
  map.put("luckiest_guy", Res.font.luckiest_guy)
}
